import React from "react";
import SectionTitle from "../../components/SectionTitle";
import SingleServiceTwo from "../../components/Service/SingleServiceTwo";

import serviceImg1 from "../../assets/img/service/service-2-1.jpg";
import serviceImg2 from "../../assets/img/service/service-2-2.jpg";
import serviceImg3 from "../../assets/img/service/service-2-3.jpg";
import serviceImg4 from "../../assets/img/service/service-2-4.jpg";
import serviceImg5 from "../../assets/img/service/service-2-5.jpg";
import serviceImg6 from "../../assets/img/service/service-2-6.jpg";

const Service = () => {
  return (
    <div className="it-service-2-area pt-120 pb-90">
      <div className="container">
        <div className="it-service-2-title-wrapper mb-65">
          <div className="row align-items-end">
            <div className="col-12">
              <SectionTitle
                itemClass="it-service-2-title-box text-center"
                subTitleClass="it-section-subtitle"
                subTitle="OUR SERVICES"
                titleClass="it-section-title"
                title="Services We Provide."
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
            <SingleServiceTwo
              serviceImage={serviceImg1}
              title="Implants"
              description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
            />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".5s">
            <SingleServiceTwo
              serviceImage={serviceImg2}
              title="Braces"
              description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
            />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".7s">
            <SingleServiceTwo
              serviceImage={serviceImg3}
              title="Teeth whitening"
              description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
            />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".8s">
            <SingleServiceTwo
              serviceImage={serviceImg4}
              title="Teeth Removal"
              description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
            />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay="1s">
            <SingleServiceTwo
              serviceImage={serviceImg5}
              title="Tooth Checkup"
              description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
            />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay="1.2s">
            <SingleServiceTwo
              serviceImage={serviceImg6}
              title="Straighten Teeth"
              description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
